// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ViewStateService {
   currentView: String;
   resultsScrollY: Number;
   subView: String;
   scopeBuilderMode: boolean;
   constructor() {
      this.currentView = "search";
      this.subView = '';
      this.resultsScrollY = 0;
      this.scopeBuilderMode = false;
   }
}

angular.module('summonApp.services')
   .service('viewStateService', ViewStateService)
